import getConfig from 'next/config';

const {publicRuntimeConfig: config} = getConfig();

const isContent = /(?:\/|-)\d{12}$/;

const sourcepointTrigger = () => {
    if (window && window._sp_ && window._sp_.mms) {
        const href = window.location.href;
        const urlAdBlockCheck = href.includes('/adblock');
        const urlContentCheck = isContent.test(location.pathname);
        const showMessage = !urlAdBlockCheck && urlContentCheck;
        window._sp_.mms.cmd.push(function () {
            window._sp_.pageChange();
            window._sp_.msg.reset();
            window._sp_.mms.setTargeting('showMessageAlways', showMessage.toString());
            window._sp_.mms.setTargeting('lang', config.language);
            window._sp_.mms.startMsg();
        });
    }
};

const sourcepointInit = () => {
    return {
        __html:
            "window._sp_ = window._sp_ || {}; window._sp_.config = window._sp_.config || {}; window._sp_.config.account_id = 332; window._sp_.config.mms_domain = 'twch.20min.ch'; window._sp_.mms = window._sp_.mms || {}; window._sp_.mms.cmd = window._sp_.mms.cmd || [];"
    };
};

export {sourcepointTrigger, sourcepointInit};
